module.exports = __webpack_public_path__ + "img/tag6.9f0a3c2a.png";